import axios from "../axios";

export const getProjectData = async () => {
  return axios.get("/api/Project/ProjectData");
};

export const getProjectTeam = async (ProjectUID) => {
  return axios.get(`/api/Project/ActiveTeam/${ProjectUID}`);
};
